export default __webpack_public_path__ + "static/media/icon-1-green-round.a6e449f4.svg";